import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Box, Dialog, DialogTitle, IconButton, 
  DialogContent, DialogActions } from '@mui/material';
import { LeagueGame, Team, ScoreAdjustment } from '../../../sdk/model';
import Close from "@mui/icons-material/Close";
import { leagueGameApi } from '../../../adapters/APIExporter';

interface editScoreProps {
  game: LeagueGame,
  teams: Team[],
  onClose: Function
}

function EditScore(props: editScoreProps) {
  const [adjustments, setAdjustments] = React.useState<ScoreAdjustment>({away: props.game.awayTeamScoreAdjustment, home: props.game.homeTeamScoreAdjustment});
  const [awayScore, setAwayScore] = React.useState(props.game.awayTeamScore);
  const [homeScore, setHomeScore] = React.useState(props.game.homeTeamScore);
  const [confirmSave, setConfirmSave] = React.useState(false);
  
  function handleChange(event) {
    const {name, value} = event.target;
    const newAdjustments = {...adjustments}
    newAdjustments[name] = value;
    setAdjustments(newAdjustments);
    const newAwayScore = props.game.awayTeamScore! - props.game.awayTeamScoreAdjustment! + Number(newAdjustments.away);
    setAwayScore(newAwayScore);
    const newHomeScore = props.game.homeTeamScore! - props.game.homeTeamScoreAdjustment! + Number(newAdjustments.home);
    setHomeScore(newHomeScore);
  }
  
  function saveAdjustment() {
    leagueGameApi.adjustScores(props.game.id!, adjustments).then(() => props.onClose())
  }
  
  const awayTeam = props.teams.find(t => t.id === props.game.awayTeamId)!;
  const homeTeam = props.teams.find(t => t.id === props.game.homeTeamId)!;
  return <Box>
  <Dialog open={confirmSave} maxWidth="sm" fullWidth>
        <DialogTitle>Manually Adjust Score?</DialogTitle>
        <Box position="absolute" top={0} right={0}>
          <IconButton onClick={() => setConfirmSave(false)}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          <Typography>Are you sure you want to manually adjust the score in this matchup?  This may affect wins and losses in the league.</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={() => setConfirmSave(false)}>
            Cancel
          </Button>
          <Button color="secondary" variant="contained" onClick={saveAdjustment}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    <Card style={{maxHeight: 800, overflow: 'auto'}}><CardContent>
      <Typography>{awayTeam.name}: {awayScore}</Typography>
      <br/>
      <TextField name="away" label="Away Score Adj: " value={adjustments.away}
          onChange={handleChange} />
      <br/><br/>
      <Typography>{homeTeam.name}: {homeScore}</Typography>
      <br/>
      <TextField name="home" label="Home Score Adj: " value={adjustments.home}
              onChange={handleChange} />
      <br/><br/>
      <Button className='capsized-button' onClick={() => setConfirmSave(true)}>Save Adjustment</Button>
    </CardContent></Card>
  </Box>
}

export default EditScore;
  